export const DEFAULT_SOURCE = 'web'
export const SOURCE_META = 'meta'
export const SOURCE_EMAIL = 'email'

export const VALID_SOURCE_VALUES = [DEFAULT_SOURCE, SOURCE_META, SOURCE_EMAIL]
